// Lib
import React from 'react';
import Icon from '../../../components/icons/Icon';

const InlineBoardIcon: React.FC = () => <Icon name="editor-inline-board" />;

export default InlineBoardIcon;
